module.exports = __webpack_public_path__ + "1418508386c0bf60c3e2a92b331ef512.png";